import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import { useCompareBar } from "./provider/compare-bar-provider";
import styles from "./compare-toggle-button.module.css";
import { useAnalytics } from "@cinch-nx/shared-analytics";
import { clickCompareVehicle, compareMaxNumberOfVehicles } from "./tracking/tracking-events";
import { datadogRum } from "@datadog/browser-rum";
export const CompareToggleButton = ({ vehicleInventoryId , make , model , modelYear , thumbnailUrl  })=>{
    const { removeVehicle , addVehicle , comparisonVehicles , setShowModal , maxNumberOfItems , customerHasActiveOrder  } = useCompareBar();
    const { trackEvent  } = useAnalytics();
    const isSavedToCompare = comparisonVehicles.some((comparisonVehicle)=>comparisonVehicle.vehicleId === vehicleInventoryId);
    const handleMaxCompareTracking = (maxNumberOfVehicles)=>{
        trackEvent(compareMaxNumberOfVehicles(maxNumberOfVehicles));
        datadogRum.addAction("Showing max compare vehicles modal", {
            service: "compare",
            squad: "product-detail",
            maxNumberOfVehicles: maxNumberOfItems
        });
    };
    const handleComparisonVehicleTracking = (make, model, vehicleInventoryId, action, value)=>{
        trackEvent(clickCompareVehicle({
            action,
            make,
            model,
            value
        }));
        datadogRum.addAction("Add vehicles for comparison clicked", {
            service: "compare",
            squad: "product-detail",
            vehicle: {
                vehicleInventoryId,
                make,
                model
            }
        });
    };
    const handleClick = ()=>{
        const numberOfVehicles = comparisonVehicles.length;
        const vehicleData = {
            vehicleId: vehicleInventoryId,
            vehicleTitle: `${modelYear} ${make} ${model}`,
            vehicleImage: thumbnailUrl,
            vehicleMake: make,
            vehicleModel: model
        };
        if (numberOfVehicles >= maxNumberOfItems && !isSavedToCompare) {
            handleMaxCompareTracking(maxNumberOfItems);
            return setShowModal(true);
        }
        if (isSavedToCompare) {
            removeVehicle(vehicleInventoryId);
            handleComparisonVehicleTracking(make, model, vehicleInventoryId, "Remove Vehicle", numberOfVehicles - 1);
        } else {
            addVehicle(vehicleData);
            handleComparisonVehicleTracking(make, model, vehicleInventoryId, "Add Vehicle", numberOfVehicles + 1);
        }
    };
    if (customerHasActiveOrder) return null;
    return /*#__PURE__*/ _jsxs("button", {
        type: "button",
        "aria-label": isSavedToCompare ? "Remove from the compare list" : "Add to the compare list",
        onClick: handleClick,
        className: cx(styles.compareToggleButton, {
            [styles.compareToggleButtonSaved]: isSavedToCompare
        }),
        children: [
            /*#__PURE__*/ _jsxs("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                fill: "none",
                viewBox: "0 0 16 16",
                className: styles.compareToggleButtonIcon,
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M14 13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h9a1 1 0 1 0 0-2H3a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 1 0-2 0v5Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M4.262 7.452a.75.75 0 1 0-1.024 1.096l1.024-1.096ZM7.5 11.5l-.512.548a.75.75 0 0 0 1.059-.034L7.5 11.5Zm8.297-7.736a.75.75 0 0 0-1.094-1.028l1.094 1.028ZM3.238 8.548l3.75 3.5 1.024-1.096-3.75-3.5-1.024 1.096Zm4.809 3.466 7.75-8.25-1.094-1.028-7.75 8.25 1.094 1.027Z"
                    })
                ]
            }),
            "Compare"
        ]
    });
};
